class ShoppableProductsDrawer extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()
    this.listeners.add(document, 'click', this.handleTriggerClick.bind(this))
  }

  async handleTriggerClick (event) {
    const trigger = event.target.closest(
      '[data-shoppable-products-drawer-external-el="trigger"]',
    )
    if (!trigger) return

    const productHandles = trigger.dataset.shoppableProductHandles?.split(',')
    if (!productHandles?.length) return

    if (!this.els.content?.exists) return

    const content = await this.buildDrawerContent(productHandles)
    if (!content) return

    this.els.content.element.innerHTML = content

    window.drawers.triggerButton = trigger
    window.drawers.activeDrawerKey = 'shoppable-products-drawer'

    document.dispatchEvent(
      new CustomEvent('drawerOpen', {
        detail: { key: 'shoppable-products-drawer' },
      }),
    )

    if (this.externalEls.drawer?.exists) {
      window.BAO.Utils.trapFocus(this.externalEls.drawer.element)
      window.setTimeout(() => {
        this.externalEls.drawer.element
          .querySelector('[data-drawers-close]')
          ?.focus()
      }, 300)
    }
  }

  async buildDrawerContent (productHandles) {
    try {
      const fetchPromises = productHandles.map(handle =>
        this.fetchProductMarkup(
          `${
            window.Shopify.routes.root
          }products/${handle}/?${new URLSearchParams({
            view: 'complete-the-style',
          }).toString()}`,
        ),
      )

      const markups = await Promise.all(fetchPromises)
      const parser = new DOMParser()

      const parsed = markups
        .filter(Boolean)
        .map(markup => {
          const doc = parser.parseFromString(markup, 'text/html')
          const root = doc.querySelector('[data-complete-the-style-product]')
          if (!root) return null
          return {
            productId: root.dataset.productId,
            productTitle: root.dataset.productTitle,
            tabHTML: doc.querySelector('[data-role="tab"]')?.innerHTML ?? '',
            panelHTML: doc.querySelector('[data-role="panel"]')?.innerHTML ?? '',
          }
        })
        .filter(Boolean)

      if (!parsed.length) return null

      if (parsed.length === 1) {
        const div = document.createElement('div')
        div.innerHTML = parsed[0].panelHTML
        div.firstElementChild?.setAttribute('aria-hidden', 'false')
        return `<div class="drw-CompleteTheStyle">${div.innerHTML}</div>`
      }

      const tabsHTML = parsed
        .map(
          (item, i) => `
          <li class="drw-CompleteTheStyle_TabsListItem">
            <button
              class="drw-CompleteTheStyle_Tab"
              aria-pressed="${i === 0 ? 'true' : 'false'}"
              aria-label="${item.productTitle}"
              data-complete-the-style-tabs-el="tab"
              data-product-id="${item.productId}"
            >
              ${item.tabHTML}
            </button>
          </li>
        `,
        )
        .join('')

      const panelsHTML = parsed
        .map((item, i) => {
          const div = document.createElement('div')
          div.innerHTML = item.panelHTML
          div.firstElementChild?.setAttribute(
            'aria-hidden',
            i === 0 ? 'false' : 'true',
          )
          return div.innerHTML
        })
        .join('')

      return `
        <complete-the-style-tabs class="drw-CompleteTheStyle">
          <div class="drw-CompleteTheStyle_Tabs">
            <ul class="drw-CompleteTheStyle_TabsList">${tabsHTML}</ul>
          </div>
          <div class="drw-CompleteTheStyle_Panels">${panelsHTML}</div>
        </complete-the-style-tabs>
      `
    } catch (error) {
      console.error(error)
      return null
    }
  }

  async fetchProductMarkup (url) {
    try {
      const response = await fetch(url)
      return await response.text()
    } catch (error) {
      console.error(error)
      return undefined
    }
  }
}

if (!customElements.get('shoppable-products-drawer')) {
  customElements.define('shoppable-products-drawer', ShoppableProductsDrawer)
}
